module.exports = __webpack_public_path__ + "static/img/female-bg-fr.76b7ece7.png";